/* eslint-disable jsx-a11y/alt-text */

import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { HOME } from "../../../routes/Paths";
import { getSelectedLanguage } from "../../../store/Checkin/languageSlice";
import {
  homePageHandler, getParametersFromLocalStorage
} from "../../../helpers/commonHelper";
import i18n from 'i18next';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import {
  SOURCE_PAGES
} from "../../../constants/constant";


const HomePageCard = ({ showModal, closeModal, resetTimerAndClosePopUp }) => {
  //  const HomePageCard = ({ showModal, closeModal, resetTimerAndClosePopUp,sourcePage}) => {

  
  const { t } = useTranslation();
  const selectedLanguage = useSelector(getSelectedLanguage);

  useEffect(async () => {
    i18n.changeLanguage(selectedLanguage);
  }, []);

  const settings = getParametersFromLocalStorage("settings");
  // console.log("--------------------------------------------------------------settings",settings);

  const finalTimeLimit = settings?.find(
    (setting) => setting.parameterName === "homePageTimerValue"
  )?.parameterValue;

  const timeLimit = isNaN(Number(finalTimeLimit)) ? 10 : Number(finalTimeLimit);

  // const timeLimit = Number(
  //   settings?.find((setting) => setting.parameterName === "homePageTimerValue")?.parameterValue
  // ) ?? 10;

  console.log("--------------------------------------------------------------timeLimit", timeLimit);
  //const timeLimit = 20;// changed from 10 to 20 for mandai
  const navigate = useNavigate();
  const [currentCount, setCurrentCount] = useState(timeLimit);

  const closeModalPopUp = () => {
    resetTimerAndClosePopUp();
  };

  const dispatch = useDispatch();

  useEffect(() => {
    if (showModal === false) handlebackPage();
  }, [showModal]);

  useEffect(() => {
    let interval = null;
    if (showModal) {
      interval = setInterval(() => {
        setCurrentCount(currentCount - 1);
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [showModal, currentCount]);



  const progressOffset = Math.round(100 - (100 * currentCount) / timeLimit);

  useEffect(() => {
    if (currentCount === 0) {
      handlebackPage();
    }
  }, [currentCount, navigate]);
  const handlebackPage = () => {
    try {
      homePageHandler(dispatch, navigate);
    } catch (error) {
      console.error("Error capturing image:", error);
    }
  };
  return (
    <div className="modal" style={{ zIndex: "9999999" }}>
      <div className="modal-dialog modal-lg modal-top">
        <div className="modal-content modal-bg">
          <div className="modal-body">
            <div className="text-center">
              {/* <div>
                <img src={personImage} />
              </div> */}

              <div className="mt-30 modal-info">
                <h6>{t("Are you sure you want to return to the home page?")}</h6>
                <h6>{t("Any unsaved progress will be lost")}</h6>
              </div>

              {/* <div className="mt-30 modal-info">
              {sourcePage === SOURCE_PAGES.RESERVATION_LIST ? ( 
                  <>
                    <h6>{t("Do you want to cancel and return to home page?")}</h6>
                    <h6>{t("Any unsaved reservation data will be lost.")}</h6>
                  </>
                ) : (
                  <>
                    <h6>{t("Are you sure you want to return to the home page?")}</h6>
                    <h6>{t("Any unsaved progress will be lost")}</h6>
                  </>
                )}
              </div> */}



            </div>
            <div className="text-center mt-30">
              <button id="btn-homapagecard-close"
                type="button"
                onClick={closeModalPopUp}
                className="btn modal-no-btn"
              >
                {t("No")}
              </button>
              <Link
                onClick={handlebackPage}
                to={HOME}
                className="btn modal-yes-btn"
              >
                {t("Yes")}
              </Link>
            </div>
            <div className="completed-status  modal-timer">
              <span style={{ color: "black" }}>{currentCount}</span>
              <div className="base-timer">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="-1 -1 34 34">
                  <circle
                    cx="16"
                    cy="16"
                    r="15.9155"
                    className="progress-bar__background"
                  />
                  <circle
                    cx="16"
                    cy="16"
                    r="15.9155"
                    className="progress-bar__progress js-progress-bar"
                    style={{ strokeDashoffset: progressOffset }}
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePageCard;
